export const DO_CENTRAL_SERVICE_URL =
  process.env.REACT_APP_DO_CENTRAL_SERVICE_URL;

export const REACT_APP_DO_BASE_URL = process.env.REACT_APP_DO_BASE_URL;

export const DO_CODE_EDITOR_LIBRARY_URL =
  process.env.REACT_APP_DO_CODE_EDITOR_LIBRARY_URL;

export const DO_INTERVIEW_SERVICE_URL =
  process.env.REACT_APP_DO_INTERVIEW_SERVICE_URL;

export const DO_AI_INTERVIEW_SERVICE_URL =
  process.env.REACT_APP_DO_AI_INTERVIEW_SERVICE_URL;

export const DOLORES_SERVICE_URL = process.env.REACT_APP_DOLORES_SERVICE_URL;

export const DO_CANDIDATE_INTERFACE =
  process.env.REACT_APP_DO_CANDIDATE_INTERFACE;

export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;

export const TALENT_CLOUD_SDK_URL = process.env.REACT_APP_TALENT_CLOUD_SDK_URL;

export const TALENT_CLOUD_SUBS_URL =
  process.env.REACT_APP_TALENT_CLOUD_SUBS_URL;

export const DO_DHWANI_SERVICE_URL =
  process.env.REACT_APP_DO_DHWANI_SERVICE_URL;
